import Vue from 'vue'

Vue.directive('can', function (el, binding) {
  const user = JSON.parse(localStorage.getItem('userInfo'))
  if (!user.permissions.includes(binding.value.replace(/'/g, '').replace(/"/g, ''))) {
    el.style.display = 'none'
  }
})